import { useEffect, useState } from "react";
import { getData, postData } from "../../../../../ApiServices/ApiService";
import { logFrontendException } from "../../../../../Utils/Exception";
import { ORG_CONFIGURATION_TEMPLETE_LIST, ORG_GET_EMPLOYEE_LIST } from "../../../../../ApiServices/BaseURL";
import { useTheme } from "../../../../../GlobalContext/GlobalContext";

const TemplateRegisterController = () => {
    const [whatsAppData, setWhatsAppData] = useState([]);
    const [whatsAppError, setWhatsAppError] = useState('');
    const [whatsAppLoading, setWhatsAppLoading] = useState(false);

    const [emailData, setEmailData] = useState([]);
    const [emailError, setEmailError] = useState('');
    const [emailLoading, setEmailLoading] = useState(false);

    const [smsData, setSmsData] = useState([]);
    const [smsError, setSmsError] = useState('');
    const [smsLoading, setSmsLoading] = useState(false);
    const pageName = "TemplateRegisterController";

    const [whatsAppStatus, setWhatsAppStatus] = useState(0);

    const [employeeList, setEmployeeList] = useState([]);
    const [empLoading, setEmpLoading] = useState(false);
    const [empError, setEmpError] = useState('');

    const { setIsLoginPopup } = useTheme();

    useEffect(() => {
        const whatsAppStatus = JSON.parse(localStorage.getItem('whatsAppStatus'));
        setWhatsAppStatus(whatsAppStatus);
        if (whatsAppStatus === 1) {
            fetchWhatsAppTemplate();
        }
    }, [])

    useEffect(() => {
        fetchUserList();
    }, [])

    const tabs = ['Email', 'SMS'];
    if (whatsAppStatus === 1) {
        tabs.unshift('WhatsApp');
    }

    const fetchTemplate = async ({ channel_name, setLoading, setError, setData, methodName }) => {
        setLoading(true);
        setError('');
        setData([]);

        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));

        try {
            const payload = {
                channel_name: channel_name,
                emp_id_auth: storedUser?.emp_id,
            };

            const response = await postData(ORG_CONFIGURATION_TEMPLETE_LIST, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.status_code === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        if (responseData?.dataJ?.length > 0) {
                            setData(responseData?.dataJ);
                        } else {
                            setError(responseData?.info || "No templates are available.");
                            logFrontendException(storedUser?.emp_id, pageName, methodName, responseData?.info);
                        }
                    } else {
                        setError(responseData?.info || "Failed to fetch templates.");
                        logFrontendException(storedUser?.emp_id, pageName, methodName, responseData?.info);
                    }
                } else {
                    setError(responseData?.info || "Unable to fetch templates.Please try again later.");
                    logFrontendException(storedUser?.emp_id, pageName, methodName, responseData);
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)
                logFrontendException(storedUser?.emp_id, pageName, methodName, response || '');
            } else {
                setError("Failed to fetch templates.Please try again.");
                logFrontendException(storedUser?.emp_id, pageName, methodName, response || '');
            }
        } catch (err) {
            setError("Unable to fetch templates.Please check your internet connection and try again.");
            logFrontendException(storedUser?.emp_id, pageName, methodName, err);
        } finally {
            setLoading(false);
        }
    };

    const fetchUserList = async () => {
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
        try {
            setEmpLoading(true);
            setEmpError('');
            setEmployeeList([]);

            // Make the API call
            const response = await getData(`${ORG_GET_EMPLOYEE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            const filterData = responseData?.dataJ.map(service => ({
                                label: service?.emp_name,
                                value: service?.emp_id
                            }));
                            setEmployeeList(filterData);
                        } else {
                            setEmpError(responseData?.info || 'Data Not Found');
                            logFrontendException(storedUserInfo?.emp_id, pageName, 'fetchUserList', responseData?.info || '');
                        }
                    } else {
                        setEmpError(responseData?.info || 'Failed to fetch User data. Please try again.');
                        logFrontendException(storedUserInfo?.emp_id, pageName, 'fetchUserList', responseData?.info || '');
                    }
                } else {
                    setEmpError(responseData?.info || 'Failed to fetch User data.');
                    logFrontendException(storedUserInfo?.emp_id, pageName, 'fetchUserList', responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setEmpError('Unauthorized access. Your session may have expired. Please log in again.');
                logFrontendException(storedUserInfo?.emp_id, pageName, 'fetchUserList-Unauthorized', response || '');
            } else {
                setEmpError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserInfo?.emp_id, pageName, 'fetchUserList', response || '');
            }
        } catch (error) {
            setEmpError(`Failed to fetch User data. Please check your network connection and try again.`);
            logFrontendException(storedUserInfo?.emp_id, pageName, 'fetchUserList', error);
        } finally {
            setEmpLoading(false);
        }
    }

    const fetchWhatsAppTemplate = () =>
        fetchTemplate({
            channel_name: 'whatsapp',
            setLoading: setWhatsAppLoading,
            setError: setWhatsAppError,
            setData: setWhatsAppData,
            methodName: 'fetchWhatsAppTemplate'
        });

    const fetchEmailTemplate = () =>
        fetchTemplate({
            channel_name: 'email',
            setLoading: setEmailLoading,
            setError: setEmailError,
            setData: setEmailData,
            methodName: 'fetchEmailTemplate'
        });

    const fetchSmsTemplate = () =>
        fetchTemplate({
            channel_name: 'sms',
            setLoading: setSmsLoading,
            setError: setSmsError,
            setData: setSmsData,
            methodName: 'fetchSmsTemplate'
        });

    useEffect(() => {
        fetchEmailTemplate();
        fetchSmsTemplate();
    }, []);

    const refreshHandlers = {
        whatsapp: fetchWhatsAppTemplate,
        email: fetchEmailTemplate,
        sms: fetchSmsTemplate,
      };

    return {
        whatsAppData,
        whatsAppError,
        whatsAppLoading,

        emailData,
        emailError,
        emailLoading,

        smsData,
        smsError,
        smsLoading,
        refreshHandlers,
        whatsAppStatus,
        tabs,
        employeeList,
        empLoading,
        empError,
    };
};

export default TemplateRegisterController;
